<template>
  <el-tabs class="tab-page" v-model="activeName" @tab-click="handleClick">
    <el-tab-pane v-for="(n, i) in data" :key="i" :label="n.label || n.name" :name="n.name">
      <slot :tabname="n.name" :data="n.data" :idx="i"></slot>
      <slot :name="n.slot"></slot>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  name: "Tab",
  props: {
    data: Array,
    tabIdx: [String, Number],
  },
  data() {
    return {
      activeName: "",
    };
  },
  mounted() {
    this.refresh()
  },
  watch: {
    tabIdx(newVal) {
      // console.log(newVal)
      this.activeName = this.data[newVal].name;
    },
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event);
      this.$emit("onToggleTab", tab, event);
    },
    refresh() {
      if (this && this.data[this.tabIdx]) {
        this.activeName = this.data[this.tabIdx].name;
      }
    },
  },
};
</script>

<style scoped>
/* .tab-page >>> .el-tabs__header {
  margin: 0 auto;
} */
.tab-page>>>.el-tabs__item {
  width: 105px;
  padding: 0;
  text-align: center;
}
</style>

<style lang="less" scoped>
.tab-page {
  /deep/ .el-tabs__header {
    padding: 0 20px;

    .el-tabs__nav-wrap {
      &::after {
        width: 0;
      }

      .el-tabs__item {
        font-size: 16px;
      }
    }
  }
}
</style>
